module.exports = __webpack_public_path__ + "static/media/400163_02.f6ea34a2.png";